export default __webpack_public_path__ + "static/media/finances-on.778c83ef.png";